import * as API from '../../api'
import { useCallback, useState } from 'react'
import { AxiosError } from 'axios'
import { Blockchain, useConnectWallet } from '@verisart/nft/src'
import { EMBEDDED_WALLET_ID } from '@verisart/nft/src/ConnectWalletContextProvider'

interface ErrorData {
  message?: string
}

const isErrorData = (data: unknown): data is ErrorData => {
  return typeof data === 'object'
}

const useClaimMint = (
  superLazyMintOrderId?: string,
  mintTo?: string,
  blockchain?: Blockchain,
  connector?: string
) => {
  const [error, setError] = useState<string>()
  const [loading, setLoading] = useState<boolean>()
  const [claimed, setClaimed] = useState<boolean>()

  const { ensureBlockchain } = useConnectWallet()

  const claimMint = useCallback(async () => {
    setLoading(true)
    setError(undefined)
    try {
      if (superLazyMintOrderId && mintTo) {
        await API.customer.claimMintNft(superLazyMintOrderId, mintTo)
        if (blockchain && connector === EMBEDDED_WALLET_ID) {
          await ensureBlockchain(blockchain)
        }
        setClaimed(true)
      }
    } catch (e: unknown) {
      const axiosError = e as AxiosError
      if (
        axiosError?.response?.status === 400 &&
        isErrorData(axiosError?.response?.data)
      ) {
        setError(axiosError.response.data.message)
      }
    } finally {
      setLoading(false)
    }
  }, [superLazyMintOrderId, mintTo, blockchain, connector, ensureBlockchain])

  return { claimMint, claimed, error, loading }
}

export default useClaimMint
